module.exports = __webpack_public_path__ + "static/media/burger-menu.2a9d489e.svg";